import { matchRoutes } from 'react-router-dom';

import { PAGE_PATHS } from '@/shared/config/pages';

/**
 * Проверяет, соответствует ли переданный путь конкретному маршруту приложения
 * @param path Проверяемый путь
 * @param targetPath Целевой маршрут
 * @returns `true`, если маршрут совпадает с заданным, иначе `false`
 */
export function isMatchingRoute(path: unknown, targetPath: string) {
  if (typeof path !== 'string') {
    return false;
  }

  const matchedRoutes = matchRoutes(PAGE_PATHS, { pathname: path });

  if (!matchedRoutes) {
    return false;
  }

  return matchedRoutes.some(route => route.route.path === targetPath);
}
